import {Time} from 'yougile-util'
import {
  getNextScheduledTime,
  Hub,
  HubJSON,
  repeatTemplatesContainerId
} from 'yougile-model'

export const getRepeatTemplateDeadlineShift = (
  template: Hub | HubJSON,
  type: 'prev-day' | 'now' = 'now'
): number => {
  if (template.location !== repeatTemplatesContainerId) {
    return 0
  }

  const repeatTemplate = template.data?.repeatTemplate
  if (!repeatTemplate?.schedule) {
    return 0
  }

  const from = type === 'prev-day' ? Time.now() - Time.day : Time.now()
  const nextRepeat = getNextScheduledTime(repeatTemplate.schedule, from)
  if (!nextRepeat) {
    return 0
  }
  const nextRepeatZero = Time.startOfDay(nextRepeat)
  const baseTemplateZeroTs = Time.startOfDay(template.timestamp)

  return nextRepeatZero - baseTemplateZeroTs
}
